export default "__VITE_ASSET__BST9gQEu__"